module.exports = __webpack_public_path__ + "static/media/color-description.bed31400.svg";